import { isValidElement } from 'react'
import { t } from 'i18next'

const displayableError = error => {
  if (!error || typeof error !== 'object' || isValidElement(error)) {
    return error ?? ''
  }

  return typeof error.message === 'string' && error.message !== '' ? error.message : t('common:field_error')
}

export default function getError(field, errors) {
  if (!errors || !errors[field]) return ''
  if (Array.isArray(errors[field])) {
    return displayableError(errors[field][0])
  }
  return displayableError(errors[field])
}
